// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ScheduleGrid\UnlistedBerthReservation.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';

// UnlistedBerthReservationData is the class that UnlistedBerthReservation serializes to/from
export interface UnlistedBerthReservationData {
    Id : number;
	
    Berth : BerthData | null;
    BerthId : number;
	
    End : /* ISO8601 */ string;
    Footmark : MeasurementData;
    Length : MeasurementData;
    Start : /* ISO8601 */ string;
}

// UnlistedBerthReservationOptions is the class which may be passed to the UnlistedBerthReservation constructor to define optional initial data values
export interface UnlistedBerthReservationOptions {
    Id : number;
	
    Berth? : BerthOptions | null;
    BerthId? : number;
	
    End? : /* ISO8601 */ string;
    Footmark? : MeasurementOptions;
    Length? : MeasurementOptions;
    Start? : /* ISO8601 */ string;
}

export class UnlistedBerthReservation {
    public Id : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthId : DataSignal<number>;
	
    public End : DataSignal<TZDate>;
    public Footmark : Measurement;
    public Length : Measurement;
    public Start : DataSignal<TZDate>;

    constructor();
    constructor(data : UnlistedBerthReservationOptions);
    constructor(data: UnlistedBerthReservationOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
	    
        this.End = jsonableObservable(S.value<TZDate>(data && data.End !== undefined ? new TZDate(data.End) : new TZDate(0), TZDate.eq));
        this.Footmark = data && data.Footmark !== undefined ? new Measurement(data.Footmark) : new Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.Start = jsonableObservable(S.value<TZDate>(data && data.Start !== undefined ? new TZDate(data.Start) : new TZDate(0), TZDate.eq));
    }

    static key(obj : UnlistedBerthReservation) {
        return obj.Id();
    }
    
    static dataKey(obj : UnlistedBerthReservationOptions) {
        return obj.Id;
    }

    static update(obj : UnlistedBerthReservation, data : UnlistedBerthReservationOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
	        
            if (data.End !== undefined) obj.End(new TZDate(data.End));
            if (data.Footmark !== undefined) Measurement.update(obj.Footmark, data.Footmark);
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.Start !== undefined) obj.Start(new TZDate(data.Start));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/UnlistedBerthReservation.ts